var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.external)?_c('li',[_c('a-link',{attrs:{"to":_vm.linkTo}},[_vm._v(_vm._s(_vm.title))])],1):_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }